document.addEventListener( 'DOMContentLoaded', () => {
	const dominosVideo = document.getElementById( 'dominoes-falling' );
	const dominosRisingVideo = document.getElementById( 'dominoes-rising' );

	if ( dominosVideo ) {

		let hasPlayed = false;
		console.log('dominoes falling exists');

		let lastScrollTop = 0;

		document.addEventListener( 'scroll', () => {

			const st = window.pageYOffset || document.documentElement.scrollTop;

			if ( st > lastScrollTop ) {
				// downscroll code
				// console.log( dominosVideo.getBoundingClientRect(), window.innerHeight );
				console.log( 'down' );
				if ( isInViewport( dominosVideo ) ) {
					console.log( 'its in the viewport!', hasPlayed );
					// dominosRisingVideo.currentTime = 0;
					// dominosVideo.play();
					if ( ! hasPlayed ) {
						// console.log( 'playing!' );
						if ( dominosVideo.closest( '.domino-falling' ).classList.contains( 'dn' ) ) {
							dominosVideo.closest( '.domino-falling' ).classList.remove( 'dn' );
						}
						if ( ! dominosRisingVideo.closest( '.domino-rising' ).classList.contains( 'dn' ) ) {
							dominosRisingVideo.closest( '.domino-rising' ).classList.add( 'dn' );
							dominosRisingVideo.currentTime = 0;
							dominosRisingVideo.pause();
						}
						// console.log( 'IT CAN BE PLAYED' );
						dominosVideo.play();
						hasPlayed = true;
					}
				}
			} else {
				// upscroll code
				// hasPlayed = false;
				// console.log( 'up' );
				if ( isInViewport( dominosVideo ) ) {
					console.log( hasPlayed );
					if ( hasPlayed ) {
						// console.log( 'hide falling' );
						dominosVideo.closest( '.domino-falling' ).classList.add( 'dn' );
						dominosRisingVideo.closest( '.domino-rising' ).classList.remove( 'dn' );
						dominosRisingVideo.play();
						dominosVideo.currentTime = 0;
						dominosVideo.pause();
						hasPlayed = false;
						// Restore the original view after 3 seconds.
						setTimeout( () => {
							dominosVideo.closest( '.domino-falling' ).classList.remove( 'dn' );
							dominosRisingVideo.closest( '.domino-rising' ).classList.add( 'dn' );
						}, 3000);
					}
				}
			}

			lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling


		}, false );

	}

} );
